import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { useState, useEffect } from 'react';

import styles from '../../styles/pages/index.module.scss';
import CustomHead from '../components/CustomHead';
import FavoriteProducts from '../components/FavoriteProducts/FavoriteProducts';
import style from '../components/FavoriteProducts/FavoriteProducts.module.scss';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Navigation from '../components/Navigation/Navigation';
import CartStore, { productsQuantities } from '../store/cart';
import CategoryStore from '../store/categories';
import DeliveryMode from '../store/deliveryMode';
import ProductsCollection from '../store/productsCollection';
import User from '../store/user';
import { getOrFetchFooterLinks } from '../utils/footerLinks';
import { getOrFetchNavigationLinks } from '../utils/navigationLinks';
import { splitProductsIntoCategories } from '../utils/products';

export default function Favorites({ navigation, footerLinks, title }) {
  const [allProductsInCollections, setAllProductsInCollections] = useState(undefined);
  const [allCategories, setAllCategories] = useState([]);
  const [categoriesShowing, setCategoriesShowing] = useState([]);
  const [productsShowing, setProductsShowing] = useState([]);
  const [quantitiesOfProducts, setQuantitiesOfProducts] = useState(undefined);
  const [isCartVisible, setIsCartVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const productsCollection$ = ProductsCollection.subscribe(setAllProductsInCollections);
    const categories$ = CategoryStore.subscribe(setAllCategories);

    const productsQuantities$ = productsQuantities.subscribe(_products => {
      setQuantitiesOfProducts(_products);
    });

    const isCartVisible$ = CartStore.getIsVisble$().subscribe(setIsCartVisible);

    return () => {
      categories$.unsubscribe();
      isCartVisible$.unsubscribe();
      productsCollection$.unsubscribe();
      productsQuantities$.unsubscribe();
    };
  }, []);

  function getProducts(list) {
    const service = DeliveryMode.getValue();
    const collectionType = DeliveryMode.getCollectionAsNumber(service);
    const _allProductsIncollections = ProductsCollection.getProductsForCollections(collectionType);
    return list.map(p => _allProductsIncollections.find(prod => p.sku === prod.sku));
  }

  function getList(data, type) {
    const dataByType = data.find(storedData => storedData.type === type);
    return dataByType?.products || [];
  }

  useEffect(() => {
    if (isEmpty(allProductsInCollections) || isEmpty(allCategories)) return;

    const userLists$ = User.getLists().subscribe(userLists => {
      const favoritesData = getList(userLists, 'favorites');
      const suggestedData = getList(userLists, 'suggested');
      const favoritesList = getProducts(favoritesData);
      const suggestedList = getProducts(suggestedData);

      const favoritedSuggestedProducts = [...favoritesList, ...suggestedList].filter(p => p);
      const [productsOrderSorted, categoriesArrayFiltered] = splitProductsIntoCategories(
        favoritedSuggestedProducts,
        allCategories
      );
      const productsOrderFiltered = productsOrderSorted.map(_products =>
        // eslint-disable-next-line implicit-arrow-linebreak
        _products?.filter((value, index, self) => self?.map(p => p._id)?.indexOf(value._id) === index)
      );
      setCategoriesShowing(categoriesArrayFiltered);
      setProductsShowing(productsOrderFiltered);
      setLoading(false);
    });

    return () => {
      userLists$.unsubscribe();
    };
  }, [allProductsInCollections, allCategories]);

  return (
    <>
      <CustomHead title={title} />
      <header className={styles.headerContainer}>
        <Header navigation={navigation} />
        <Navigation navigation={navigation} />
      </header>
      <div className={cn({ [style.spaceOpenCart]: isCartVisible })}>
        <FavoriteProducts
          categoriesShowing={categoriesShowing}
          productsShowing={productsShowing}
          quantitiesOfProducts={quantitiesOfProducts}
          loading={loading}
        />
      </div>
      <Footer footerLinks={footerLinks} />
    </>
  );
}

export async function getStaticProps() {
  const [{ data: navigation }, footerLinks] = await Promise.all([getOrFetchNavigationLinks(), getOrFetchFooterLinks()]);

  const title = `Αγαπημένα Προϊόντα`;
  return {
    props: { navigation, footerLinks, title },
  };
}
